import { render, staticRenderFns } from "./CheckBoxes.vue?vue&type=template&id=0f5b7459&scoped=true&"
import script from "./CheckBoxes.vue?vue&type=script&lang=js&"
export * from "./CheckBoxes.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxes.vue?vue&type=style&index=0&id=0f5b7459&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5b7459",
  null
  
)

export default component.exports